import {
  SET_CARD_FILTERS,
  SET_POSTER_FILTERS,
  SET_CARD_VIEW,
  // BLOG
  SET_BLOG_FETCHER,
  SET_BLOG_FILTERS,
  // NEWS
  SET_NEWS_FETCHER,
  SET_NEWS_FILTERS,
  // ENQUIRY
  SET_ENQ_FETCHER,
  SET_ENQ_FILTERS,
  // REVIEW
  SET_REV_FETCHER,
  SET_REV_FILTERS,
  // SURVEY
  SET_QR_FILTERS,
  //
  SET_INV_FETCHER,
  SET_INV_FILTERS,
  //
  SET_RES_FETCHER,
  SET_RES_FILTERS,
  //
  SET_OVERVIEW_FILTERS,
  SET_HEADLINE_FILTERS,
  SET_DASHBOARD_FILTERS,
  //
  SET_SURVEY_FETCHER,
  SET_SURVEY_FILTERS,
  RESET_ENQ_FILTERS,
  SET_REPORT_FILTERS,
  //
  SET_SURVEY_DATA,
  //
  SET_EMP_FETCHER,
  SET_EMP_FILTERS,
  //
  SET_WEBENQ_FETCHER,
  SET_WEBENQ_FILTERS,
} from "./constants";

export const setCardFilters = (payload) => ({
  type: SET_CARD_FILTERS,
  payload,
});

export const setPosterFilters = (payload) => ({
  type: SET_POSTER_FILTERS,
  payload,
});

export const setCardView = (payload) => ({
  type: SET_CARD_VIEW,
  payload,
});

//
export const setBlogFetchter = (payload) => ({
  type: SET_BLOG_FETCHER,
  payload,
});
export const setBlogFilters = (payload) => ({
  type: SET_BLOG_FILTERS,
  payload,
});

//
export const setNewsFetchter = (payload) => ({
  type: SET_NEWS_FETCHER,
  payload,
});
export const setNewsFilters = (payload) => ({
  type: SET_NEWS_FILTERS,
  payload,
});

//
export const setEnqFetchter = (payload) => ({
  type: SET_ENQ_FETCHER,
  payload,
});
export const setEnqFilters = (payload) => ({
  type: SET_ENQ_FILTERS,
  payload,
});

//
export const setRevFetchter = (payload) => ({
  type: SET_REV_FETCHER,
  payload,
});
export const setRevFilters = (payload) => ({
  type: SET_REV_FILTERS,
  payload,
});

//
export const setQrFilters = (payload) => ({
  type: SET_QR_FILTERS,
  payload,
});

//
export const setInvFetchter = (payload) => ({
  type: SET_INV_FETCHER,
  payload,
});
export const setInvFilters = (payload) => ({
  type: SET_INV_FILTERS,
  payload,
});

//
export const setResFetchter = (payload) => ({
  type: SET_RES_FETCHER,
  payload,
});
export const setResFilters = (payload) => ({
  type: SET_RES_FILTERS,
  payload,
});

//
export const setOverviewFilters = (payload) => ({
  type: SET_OVERVIEW_FILTERS,
  payload,
});
export const setHeadlineFilters = (payload) => ({
  type: SET_HEADLINE_FILTERS,
  payload,
});
export const setDashboardFilters = (payload) => ({
  type: SET_DASHBOARD_FILTERS,
  payload,
});

export const setSurveyFetchter = (payload) => ({
  type: SET_SURVEY_FETCHER,
  payload,
});
export const setSurveyFilters = (payload) => ({
  type: SET_SURVEY_FILTERS,
  payload,
});
export const resetEnqFilters = (payload) => ({
  type: RESET_ENQ_FILTERS,
  payload,
});
export const setReportFilters = (payload) => ({
  type: SET_REPORT_FILTERS,
  payload,
});

export const setSurveyData = (payload) => ({
  type: SET_SURVEY_DATA,
  payload,
});

export const setEmpFetchter = (payload) => ({
  type: SET_EMP_FETCHER,
  payload,
});
export const setEmpFilters = (payload) => ({
  type: SET_EMP_FILTERS,
  payload,
});

export const setWebEmpFetchter = (payload) => ({
  type: SET_WEBENQ_FETCHER,
  payload,
});
export const setWebEmpFilters = (payload) => ({
  type: SET_WEBENQ_FILTERS,
  payload,
});
